<template>
  <div>
    <div
      v-if="!showMemberProfile"
      class="d-flex align-items-center"
    >
      <HubAvatar
        :user-id="Number(userId)"
        :avatar-style="avatarStyle"
        :users-avatars="userAvatars"
      ></HubAvatar>
      <div class="font-weight-normal ml-5 ellipsis">
        {{ name }}
      </div>
      <AppTooltipIcon
        v-if="title"
        class="a-tooltip ml-5 mt-4"
        text-type="lighter"
        :message="title"
        placement="top"
        :size="12"
      />
    </div>

    <AppPopover
      v-else
      ref="AppPopover"
      v-tooltip="{ closeOnClick: true }"
      placement="top"
      hide-close="hide-close"
      lazy="lazy"
      popover-container-classes="max-w-full"
      extra-popover-classes="member-popover"
      span-class="align-items-center"
      :hide-from-action="hideMemberPopover"
      data-tipclass="member-popover-tooltip"
      data-original-title="View profile summary"
    >
      <PopoverAvatarUserCard
        :key="userId"
        :user-id="Number(userId)"
        :organization-id="Number(organizationId)"
        :tab="tab"
        target="_blank"
      ></PopoverAvatarUserCard>
      <HubAvatar
        slot="trigger"
        :user-id="Number(userId)"
        role="button"
        :avatar-style="avatarStyle"
        :users-avatars="userAvatars"
      ></HubAvatar>
      <div
        slot="trigger"
        class="clickable hover-underline font-weight-normal ml-5 ellipsis"
      >
        {{ name }}
      </div>
      <AppTooltipIcon
        v-if="title"
        slot="trigger"
        class="a-tooltip ml-5 mt-4"
        text-type="lighter"
        :message="title"
        placement="top"
        :size="12"
      />
    </AppPopover>
  </div>
</template>

<script>
import PopoverAvatarUserCard from '~/components/PopoverAvatarUserCard.vue';
import AppPopover from '~/components/AppPopover.vue';
import HubAvatar from '~/components/HubAvatar.vue';
import AppTooltipIcon from '~/components/AppTooltipIcon.vue';

export default {
  name: 'MemberPaymentAccountPopup',
  components: {
    AppPopover,
    PopoverAvatarUserCard,
    HubAvatar,
    AppTooltipIcon,
  },
  props: {
    organizationId: {
      type: [String, Number],
      required: true,
    },
    userId: {
      type: [String, Number],
      required: true,
    },
    imageUrl: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    tab: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    avatarStyle: {
      type: String,
      default: 'medium',
    },
    hideMemberPopover: {
      type: Boolean,
      default: false,
    },
    showMemberProfile: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    userAvatars() {
      const map = new Map();

      map.set(this.userId, this.imageUrl);

      return map;
    },
  },
};
</script>
